import filter from 'lodash/filter'
import get from 'lodash/get'

const roleFor = (state, role) => {
  if (state && state.current_user && state.current_user.companyRoles) {
    return filter(state.current_user.companyRoles, { [role]: true }).map(o => o.companyId)
  }
  return []
}

const hasRole = (state, role) => {
  if (state && state.current_user && state.current_user.companyRoles) {
    return Boolean(filter(state.current_user.companyRoles, { [role]: true }).length)
  }
  return false
}
const hasCompanyDepartments = (state, compId) => {
  const employments = get(state, 'current_user.employments', [])
  if (employments.length > 0 && compId === 0) {
    return Boolean(employments.find(x => x.company.hasDepartments == true))
  }
  else if (employments && compId > 0) {
    let found = employments.find(x => x.companyId == compId)

    if (found && found.company && found.company.hasDepartments) {
      return true
    }
    return false
  }
  return false
}

const isDepartmentRole = (state, compId, role) => {
  const employments = get(state, 'current_user.employments', [])
  if (compId == 0) {
    let ret = false
    employments.forEach(e => {
      if (e.departmentEmployments.find(x => x[role] == true)) {
        ret = true
      }
    });
    return ret
  }
  let employment = employments.find(x => x.companyId == compId)
  if (employment && employment.departmentEmployments && employment.departmentEmployments.find(d => d[role])) {
    return true
  }
  return false
}

const isDepartmentEducationResponsible = (state, compId) => {
  return isDepartmentRole(state, compId, 'isDepartmentEducationResponsible')
}

const isDepartmentInstructor = (state, compId) => {
  return isDepartmentRole(state, compId, 'isDepartmentInstructor')
}

const isDepartmentDistanceEducationAdministrator = (state, compId) => {
  return isDepartmentRole(state, compId, 'isDepartmentDistanceEducationAdministrator')
}

const isDepartmentAdmin = (state, compId) => {
  return isDepartmentRole(state, compId, 'isDepartmentAdministrator')
}

const getters = {
  currentUserObj: state => {
    return state.current_user ? state.current_user : null
  },
  currentUserId: state => {
    return state.current_user && state.current_user.id ? state.current_user.id : null
  },
  currentUser: state => {
    return state.current_user ? state.current_user : null
  },
  isLoggedIn: state => {
    return Boolean(state.current_user)
  },
  isApprentice: state => {
    return Boolean(
      state.current_user && state.current_user.apprenticeships && state.current_user.apprenticeships.length
    )
  },
  isAdministrator: state => {
    return hasRole(state, 'Administrator')
  },
  isAdministratorFor: state => {
    return roleFor(state, 'Administrator')
  },
  isDistanceEducationAdministrator: state => compId => {
    if (hasCompanyDepartments(state, compId) == true) {
      return isDepartmentDistanceEducationAdministrator(state, compId)
    }
    return hasRole(state, 'DistanceEducationAdministrator')

  },
  isDepartmentAdministrator: state => compId => {
    if (hasCompanyDepartments(state, compId) == true) {
      return isDepartmentAdmin(state, compId)
    }
    return false
  },
  isAdmin: state => compId => {
    if (hasRole(state, 'Administrator'))
      return true
    else if (hasCompanyDepartments(state, compId) == true) {
      return Boolean(isDepartmentAdmin(state, compId))
    }
    return false
  },
  isDistanceEducationAdministratorFor: state => {
    return roleFor(state, 'DistanceEducationAdministrator')
  },
  isCompanyEducationResponsible: state => compId => {
    if (hasCompanyDepartments(state, compId) == true) {
      return isDepartmentEducationResponsible(state, compId)
    }
    return hasRole(state, 'CompanyEducationResponsible')
  },
  isCompanyEducationResponsibleFor: state => {
    return roleFor(state, 'CompanyEducationResponsible')
  },
  isInstructor: state => compId => {
    if (hasCompanyDepartments(state, compId) == true) {
      return isDepartmentInstructor(state, compId)
    }
    return hasRole(state, 'Instructor')
  },
  isInstructorFor: state => {
    return roleFor(state, 'Instructor')
  },
  isCompanyUser: state => compId => {
    if (hasCompanyDepartments(state, compId) == true) {
      return Boolean(
        hasRole(state, 'Administrator') ||
        isDepartmentEducationResponsible(state, compId) ||
        isDepartmentDistanceEducationAdministrator(state, compId) ||
        isDepartmentInstructor(state, compId) ||
        isDepartmentAdmin(state, compId)
      )
    }

    return Boolean(
      hasRole(state, 'Administrator') ||
      hasRole(state, 'CompanyEducationResponsible') ||
      hasRole(state, 'DistanceEducationAdministrator') ||
      hasRole(state, 'Instructor')
    )

  },

  isOnlyInstructor: state => {
    return Boolean(
      hasRole(state, 'Instructor') && !(
        hasRole(state, 'Administrator') ||
        hasRole(state, 'CompanyEducationResponsible') ||
        hasRole(state, 'DistanceEducationAdministrator')
      )
    )
  },
  isAdminUser: state => compId => {
    if (hasCompanyDepartments(state, compId) == true) {
      return Boolean(
        hasRole(state, 'Administrator') ||
        isDepartmentEducationResponsible(state, compId) ||
        isDepartmentDistanceEducationAdministrator(state, compId) ||
        isDepartmentAdmin(state, compId)
      )
    }

    return Boolean(
      hasRole(state, 'Administrator') ||
      hasRole(state, 'CompanyEducationResponsible') ||
      hasRole(state, 'DistanceEducationAdministrator')
    )
  },
  isRegistered: state => {
    return Boolean(state.current_user && state.current_user.phoneVerified && state.current_user.emailVerified)
  },
  rolesList: state => {
    let roles = []
    if (hasRole(state, 'Administrator')) roles.push('FTGADM')
    if (hasRole(state, 'CompanyEducationResponsible')) roles.push('YUA')
    if (hasRole(state, 'DistanceEducationAdministrator')) roles.push('BG')
    if (hasRole(state, 'Instructor')) roles.push('HL')
    if (state.current_user && state.current_user.apprenticeships && state.current_user.apprenticeships.length)
      roles.push('LÄR')
    return roles.join(', ')
  },

  notifications: state => {
    return state.notifications ? state.notifications : []
  },
  unreadNotificationCount: state => {
    return filter(state.notifications, { readTime: null }).length
  },
  hasTradeCertificates: state => {
    return Boolean(state.current_user && state.current_user.tradeCertificates && state.current_user.tradeCertificates.length > 0)
  },
  currentUserTradeCertificatesProfessions: (state, getters, rootState, rootGetters) => {
    const tcs = get(state, "current_user.tradeCertificates", [])
    let tcNames
    try {
      tcNames = tcs.map(tc => rootGetters['basic/getProfessionNameById'](tc.professionId)).join(', ')
    } catch (e) {
      tcNames = 'ett yrke'
    }
    return tcNames
  },

  isImitatingUser: state => () =>  {
    return state.current_user && state.current_user && state.current_user.imitatingUser && !state.current_user.imitatingUser.userrole.isAdmin
  }
}

export default getters
